'use strict';

angular.module('programme')

.directive('quoteParagraph', function ()
{
    function link ($scope, element)
    {
        $scope.ctrl.setFocusRequestHandler(function ()
        {
            element.find('p')[0].focus();
        });
    }

    return {
        restrict: 'A',
        templateUrl: 'modules/programme/editor-components/quote-paragraph/quoteParagraph.html',
        link: link,
        controller: function($scope)
        {
            $scope.data.rightToLeft = $scope.data.rightToLeft || false;
        }
    };
});
